import { Typography, Box } from "@mui/material";
import Grid from "@mui/material/Grid2";
import CriSection from "../../../components/CriSection";
import StaffCard from "./StaffCard";
import { StaffList, StaffListType } from "../../../constants/staff_list";
import { Key } from "react";

const StaffSection = () => {
  return (
    <CriSection>
      <Box
        sx={{
          marginBottom: "50px",
        }}
      >
        <Typography
          sx={{
            fontSize: "36px",
            fontWeight: 400,
            marginBottom: "2px",
          }}
        >
          Our Team
        </Typography>

        <Typography
          sx={{
            fontSize: "20px",
            marginBottom: "24px",
          }}
        >
          Meet the people behind the research projects at the Conservation
          Research Institute
        </Typography>
      </Box>

      <Grid container spacing={{ xs: 2, md: 8 }}>
        {StaffList.map(
          (staff: StaffListType, index: Key | null | undefined) => (
            <Grid size={{ xs: 6, md: 3 }}>
              <StaffCard
                key={index}
                image={staff.image}
                name={staff.name}
                position={staff.position}
              />
            </Grid>
          )
        )}
      </Grid>
    </CriSection>
  );
};

export default StaffSection;
